import React from "react";
import { useOutletContext } from "react-router-dom";
import DashboardHeader from "../components/Other/DashboardHeader";
import PageHeaderTitle from "../components/pages/PageHeaderTitle";
import PageContainer from "../components/pages/PageContainer";
import SettingsPageHeading from "../components/pages/SettingsPageHeading";
import { event } from "../utils/event";

// Client-confirmed values.
const APP_VERSION = "2.9";
const CONTACT_EMAIL = "contact@qushi.io";
const QUSHI_URL = "https://qushi.io";

const AboutQushi = () => {
  const [sidebarToggle] = useOutletContext();

  // Same mechanism Settings uses for external links: on the Flutter shell we
  // fire an event so the native in-app browser opens the URL; on web we open a
  // new tab. This keeps "View QUSHi.io" inside the app browser on mobile.
  const flutterMobile = localStorage.getItem("isFlutterInAppWebViewReady");
  const openWebsite = () => {
    if (!flutterMobile) {
      const newTab = window.open();
      if (newTab) {
        newTab.opener = null;
        newTab.location.href = QUSHI_URL;
      }
    } else {
      event("about_us", QUSHI_URL);
    }
  };

  return (
    <>
      <DashboardHeader toggle={sidebarToggle} />
      {/* Settings sitewide: no desktop title/grey line, no mobile under-logo title. */}
      <PageHeaderTitle title="About QUSHi" showDesktopTitle={false} />
      <PageContainer>
        <div className="px-4 pt-4 md:pt-10 md:px-0 md:max-w-[55rem] md:mx-auto">
          <SettingsPageHeading title="About QUSHi" className="mb-3 md:mb-4" />
          <div className="md:rounded-2xl md:border md:border-gray-200 md:bg-white md:p-8">
            {/* Informational first — capped to the body-copy reading measure. */}
            <p className="text-sm leading-relaxed text-gray-700 md:max-w-body-copy">
              QUSHi is a simulated trading, education, and community platform
              built for practice, competition, and transparent track records.
            </p>

            {/* Version + Contact: two columns on desktop — Version left at the
                card's content edge, Contact ~96px to its right so they read as
                distinct. Stacked on mobile. */}
            <div className="mt-6 md:flex md:gap-24">
              <div>
                <p className="text-xs font-semibold uppercase tracking-wide text-tertiary">
                  Version
                </p>
                <p className="mt-1 text-sm text-gray-800">{APP_VERSION}</p>
              </div>
              <div className="mt-5 md:mt-0">
                <p className="text-xs font-semibold uppercase tracking-wide text-tertiary">
                  Contact
                </p>
                <a
                  href={`mailto:${CONTACT_EMAIL}`}
                  className="mt-1 inline-block text-sm text-primaryColor underline-offset-2 hover:underline"
                >
                  {CONTACT_EMAIL}
                </a>
              </div>
            </div>

            {/* Optional next step — kept near the bottom, not directly under the
                intro, so the screen reads as informational first. */}
            <div className="mt-10">
              <button
                type="button"
                onClick={openWebsite}
                className="rounded-lg border border-[#004c50] bg-white px-5 py-2.5 font-medium text-[#004c50] transition-colors hover:bg-[#f3faf9]"
              >
                View QUSHi.io
              </button>
            </div>
          </div>
        </div>
      </PageContainer>
    </>
  );
};

export default AboutQushi;
